export const selectDialsData = (state) => state.dialer.dials;
export const selectDialsToSync = (state) => state.dialer.dialsToSync;
export const selectDialsToDelete = (state) => state.dialer.dialsToDelete;
export const selectDialsLastSyncDate = (state) => state.dialer.lastSync;

